module.exports = __webpack_public_path__ + "static/media/despesa.498ab5ac.png";